const funds = [
  {
    name: "Community Local Infrastructure Recovery Program",
    icon: "/img/icon-1.svg",
    pin: "/img/pins/pin-1.svg",
  },
];

const iconsByFundName = funds.reduce((acc, fund) => {
  acc[fund.name] = fund.icon;
  return acc;
}, {});
const pinsByFundName = funds.reduce((acc, fund) => {
  acc[fund.name] = fund.pin;
  return acc;
}, {});
export const fundByName = funds.reduce((acc, fund) => {
  acc[fund.name] = fund;
  return acc;
}, {});
// Use black pin as default
export const getIcon = (fundName) => {
  return iconsByFundName[fundName] || "/img/black-pin.svg";
};
export const getPin = (fundName) => {
  return pinsByFundName[fundName] || "/img/black-pin.svg";
};



// WEBPACK FOOTER //
// ./src/modules/fund.js